import { useApp } from "@/context/AppContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useApp();
  const current = languages.find(l => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="lang-trigger" className="flex items-center gap-2 px-3 py-2 text-[11px] tracking-[0.15em] uppercase border border-white/15 hover:border-gold text-white transition-colors">
        <span className="text-base leading-none">{current.flag}</span>
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
        <ChevronDown size={12} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-black border-white/10 min-w-[180px]"
        data-testid="lang-menu"
      >
        {languages.map(l => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`flex items-center gap-3 cursor-pointer text-white hover:bg-white/5 hover:text-gold ${l.code === lang ? "text-gold" : ""}`}
          >
            <span className="text-base leading-none">{l.flag}</span>
            <span className="text-sm">{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
